export * as Api from './api';
export var AuthGateDecision;
(function (AuthGateDecision) {
    AuthGateDecision["ChooseAccount"] = "choose-account";
    AuthGateDecision["CopyProfile"] = "copy-profile";
})(AuthGateDecision || (AuthGateDecision = {}));
export var LpEmailPermission;
(function (LpEmailPermission) {
    LpEmailPermission["CapitalNotices"] = "lp:capital-notices";
    LpEmailPermission["Reporting"] = "lp:reporting";
    LpEmailPermission["Administration"] = "lp:administration";
})(LpEmailPermission || (LpEmailPermission = {}));
export var InvestorAccessPermission;
(function (InvestorAccessPermission) {
    InvestorAccessPermission["EditAll"] = "edit:all";
    InvestorAccessPermission["CreateAll"] = "create:all";
    InvestorAccessPermission["ReadAll"] = "read:all";
    InvestorAccessPermission["SignDocuments"] = "sign:documents";
})(InvestorAccessPermission || (InvestorAccessPermission = {}));
export var EisInvestorAccessPermissionGroupKey;
(function (EisInvestorAccessPermissionGroupKey) {
    EisInvestorAccessPermissionGroupKey["Full"] = "Full";
    EisInvestorAccessPermissionGroupKey["ReadOnly"] = "ReadOnly";
})(EisInvestorAccessPermissionGroupKey || (EisInvestorAccessPermissionGroupKey = {}));
export const EisInvestorAccessPermissionGroup = {
    [EisInvestorAccessPermissionGroupKey.Full]: [
        InvestorAccessPermission.EditAll,
        InvestorAccessPermission.CreateAll,
        InvestorAccessPermission.ReadAll,
    ],
    [EisInvestorAccessPermissionGroupKey.ReadOnly]: [
        InvestorAccessPermission.ReadAll,
    ],
};
export var LpInvestorAccessPermissionGroupKey;
(function (LpInvestorAccessPermissionGroupKey) {
    LpInvestorAccessPermissionGroupKey["Full"] = "Full";
    LpInvestorAccessPermissionGroupKey["ReadOnly"] = "ReadOnly";
    LpInvestorAccessPermissionGroupKey["FullExceptSigning"] = "FullExceptSigning";
})(LpInvestorAccessPermissionGroupKey || (LpInvestorAccessPermissionGroupKey = {}));
export const LpInvestorAccessPermissionGroup = {
    [LpInvestorAccessPermissionGroupKey.Full]: [
        InvestorAccessPermission.EditAll,
        InvestorAccessPermission.CreateAll,
        InvestorAccessPermission.ReadAll,
        InvestorAccessPermission.SignDocuments,
    ],
    [LpInvestorAccessPermissionGroupKey.FullExceptSigning]: [
        InvestorAccessPermission.EditAll,
        InvestorAccessPermission.CreateAll,
        InvestorAccessPermission.ReadAll,
    ],
    [LpInvestorAccessPermissionGroupKey.ReadOnly]: [
        InvestorAccessPermission.ReadAll,
    ],
};
export var FurtherUserErrorCode;
(function (FurtherUserErrorCode) {
    FurtherUserErrorCode["ImpersonationFirmMismatch"] = "IMPERSONATION_FIRM_MISMATCH";
    FurtherUserErrorCode["OrgUserFirmRestricted"] = "ORG_USER_FIRM_RESTRICTED";
})(FurtherUserErrorCode || (FurtherUserErrorCode = {}));
//# sourceMappingURL=index.js.map